import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { COBRANZA_REJECTED_POLICIES_ACTION, COBRANZA_REJECTED_POLICY_NO_CODE, COBRANZA_REJECTED_POLICY_NO_NAME, COBRANZA_SUMMARY_AMOUNT_LABEL, COBRANZA_SUMMARY_CURRENCY_SYMBOL, COBRANZA_SUMMARY_PAYMENT_METHOD_LABEL, COBRANZA_SUMMARY_PAYMENT_METHOD_SEPARATOR, COBRANZA_SUMMARY_POLICIES_LABEL, cobranzaRejectionTitle, cobranzaSummaryAccountsUnit, cobranzaSummaryCardsUnit, } from "../../../constants/cobranza.constants";
import { SummaryKpiUnit } from "../style/collectionSummary.style";
var CLOSED_MODAL = {
    opened: false,
    title: "",
    rows: [],
    onClose: function () { return undefined; },
};
var formatCount = function (count) { return count.toLocaleString("en-US"); };
var buildPaymentMethodValue = function (summary) { return (_jsxs(_Fragment, { children: [formatCount(summary.cardsCount), " ", _jsx(SummaryKpiUnit, { children: cobranzaSummaryCardsUnit(summary.cardsCount) }), " ", COBRANZA_SUMMARY_PAYMENT_METHOD_SEPARATOR, " ", formatCount(summary.accountsCount), " ", _jsx(SummaryKpiUnit, { children: cobranzaSummaryAccountsUnit(summary.accountsCount) })] })); };
var formatAmount = function (amount) {
    return "".concat(COBRANZA_SUMMARY_CURRENCY_SYMBOL).concat(amount.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }));
};
var buildKpis = function (summary) { return [
    {
        id: "policies",
        value: formatCount(summary.policiesCount),
        label: COBRANZA_SUMMARY_POLICIES_LABEL,
        tone: "neutral",
    },
    {
        id: "amount",
        value: formatAmount(summary.amountToCollect),
        label: COBRANZA_SUMMARY_AMOUNT_LABEL,
        tone: "pos",
    },
    {
        id: "paymentMethod",
        value: buildPaymentMethodValue(summary),
        label: COBRANZA_SUMMARY_PAYMENT_METHOD_LABEL,
        tone: "neutral",
    },
]; };
var cleanText = function (value) { return (value !== null && value !== void 0 ? value : "").replace(/\s+/g, " ").trim(); };
var toPolicyRows = function (policies) {
    return policies.map(function (policy, index) {
        var code = cleanText(policy.policyCode);
        var name = cleanText(policy.name);
        return {
            id: "".concat(policy.policyId, "-").concat(index),
            code: code ||
                "".concat(COBRANZA_REJECTED_POLICY_NO_CODE, " \u00B7 ").concat(policy.policyId.slice(0, 8)),
            name: name || COBRANZA_REJECTED_POLICY_NO_NAME,
            hasCode: Boolean(code),
            hasName: Boolean(name),
        };
    });
};
var buildNotices = function (summary) {
    return summary.rejections.map(function (rejection) { return ({
        id: "".concat(rejection.kind, ":").concat(rejection.reason),
        tone: rejection.kind === "error" ? "warn" : "info",
        title: cobranzaRejectionTitle(rejection.reason, rejection.count),
        actionLabel: rejection.policies.length > 0
            ? COBRANZA_REJECTED_POLICIES_ACTION
            : undefined,
        policies: toPolicyRows(rejection.policies),
    }); });
};
export var useCollectionSummary = function (props) {
    var _a = useState(null), openedNoticeId = _a[0], setOpenedNoticeId = _a[1];
    if (props.summary.status === "hidden") {
        return {
            hasSummary: false,
            kpis: [],
            notices: [],
            modal: CLOSED_MODAL,
            onOpenNotice: setOpenedNoticeId,
        };
    }
    var notices = buildNotices(props.summary.data);
    var openedNotice = notices.find(function (notice) { return notice.id === openedNoticeId; });
    return {
        hasSummary: true,
        kpis: buildKpis(props.summary.data),
        notices: notices,
        modal: openedNotice
            ? {
                opened: true,
                title: openedNotice.title,
                rows: openedNotice.policies,
                onClose: function () { return setOpenedNoticeId(null); },
            }
            : CLOSED_MODAL,
        onOpenNotice: setOpenedNoticeId,
    };
};
